import { EventType, PageType, SearchCategory } from '@/Tracking/types';

export default class Search {
  event: EventType;
  pageType: PageType | string;
  searchCategory: SearchCategory;
  searchTerm?: string;
}
